import { get } from '@alltrails/core/utils/get';
import type { TrailId } from '@alltrails/types/TrailId';

export default function getActivities(trailId: TrailId, currPage: number) {
  return get(`/api/alltrails/v2/trails/${trailId}/maps`, {
    params: {
      page: currPage + 1,
      per_page: 6,
      presentation_type: 'track'
    }
  });
}
